var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TopMentionComponent } from '../top-mention/top-mention.component';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
var TopMentionPlaceholderComponent = /** @class */ (function (_super) {
    __extends(TopMentionPlaceholderComponent, _super);
    function TopMentionPlaceholderComponent(pdfService, userService) {
        var _this = _super.call(this, pdfService, userService) || this;
        _this.pdfService = pdfService;
        _this.userService = userService;
        _this.data = [];
        for (var i = 0; i < 10; i++) {
            _this.data.push({ keyword: '', number: 10, bgColor: '#f7f7f8' });
        }
        _this.isFallbackView = true;
        return _this;
    }
    return TopMentionPlaceholderComponent;
}(TopMentionComponent));
export { TopMentionPlaceholderComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/top-mention-placeholder/top-mention-placeholder.component.ts.pre-build-optimizer.js